// platforms
export const isIOS = () => /(iphone|ipad|ipod)/i.test(navigator.userAgent);
export const isAndroid = () => /(android)/i.test(navigator.userAgent);

// iPad detection that also covers iPadOS 13+, which reports as desktop Safari
// ("MacIntel") and can only be told apart by the presence of touch points.
export const isIpad = () => {
  if (typeof navigator === 'undefined') return false;
  return (
    /ipad/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1)
  );
};

// Coarse device buckets used for things like picking an optimized image variant.
// Centralized here so components don't re-implement width/UA sniffing.
export const DEVICE = { MOBILE: 'mobile', TABLET: 'tablet', DESKTOP: 'desktop' };

// Breakpoints (px). Tablet spans [TABLET_MIN, DESKTOP_MIN).
const TABLET_MIN_WIDTH = 768;
const DESKTOP_MIN_WIDTH = 1024;

// Best-effort device bucket from viewport width + iPad UA. Safe on the server
// (defaults to desktop). Read at call time — pass an explicit width to make it
// deterministic/testable.
export const getDeviceType = (
  width = typeof window !== 'undefined'
    ? window.innerWidth || (document.documentElement && document.documentElement.clientWidth) || 0
    : 0,
) => {
  if (typeof window === 'undefined') return DEVICE.DESKTOP;
  // iPads report a wide range of widths (incl. desktop-like); treat as tablet.
  if (isIpad()) return DEVICE.TABLET;
  if (width < TABLET_MIN_WIDTH) return DEVICE.MOBILE;
  if (width < DESKTOP_MIN_WIDTH) return DEVICE.TABLET;
  return DEVICE.DESKTOP;
};

// browsers
export const isSamsungBrowser = () => /(SamsungBrowser)/.test(navigator.userAgent);

// webview
export const isWebView = (ua) => {
  if (isAndroid) return /(wv|Version)/.test(ua);
  if (isIOS) return !(/(safari)/i.test(ua));
  return false;
};
